import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M5.64 9l-.6 3h13.92l-.6-3z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 7l-1 5v2h1v6h10v-6h4v6h2v-6h1v-2l-1-5H4zm8 11H6v-4h6v4zm-6.96-6l.6-3h12.72l.6 3H5.04zM4 4h16v2H4z"
})), 'StoreMallDirectoryTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/StoreMallDirectoryTwoTone.js
// module id = 6523
// module chunks = 2